const Help = ({children, className=""})=>{
    return <div className={`text-md ${className}`}>
        {children}
    </div>

}

export default Help
